import { isArticlePage, isAuthorMode, isLiveBlogPage } from '../../utils/aem-utils';
import { isHomepageInArticle } from '../../utils/injected-hp-utils';

export const injectedHomepageModule = {
  name: 'Injected Homepage',
  shouldInit: () => !isAuthorMode() && isHomepageInArticle() && (isLiveBlogPage() || isArticlePage()),
};
